import { Box } from "@primer/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MainNavigation } from "./MainNavigation";
import { Header } from "./Header";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const isTemplateEditorRoute = (pathname: string) =>
  pathname === "/dashboard/templates/new" ||
  pathname.startsWith("/dashboard/templates/edit/");

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const location = useLocation();
  const hideSidebar = isTemplateEditorRoute(location.pathname);

  useEffect(() => {
    const syncModalChrome = () => {
      const modalIsOpen = Boolean(
        document.querySelector(
          '[role="dialog"], .feedback-overlay, [class*="Dialog__Backdrop"]',
        ),
      );
      document.body.classList.toggle("app-modal-open", modalIsOpen);
    };

    const observer = new MutationObserver(syncModalChrome);
    observer.observe(document.body, { childList: true, subtree: true });
    syncModalChrome();

    return () => {
      observer.disconnect();
      document.body.classList.remove("app-modal-open");
    };
  }, []);

  return (
    <Box className="app-shell" data-editor-mode={hideSidebar || undefined}>
      {!hideSidebar && (
        <Box as="aside" className="app-sidebar">
          <MainNavigation />
        </Box>
      )}

      <Box className="app-workspace">
        <Header editorMode={hideSidebar} />
        <Box as="main" className="app-content">
          {children}
        </Box>
      </Box>
    </Box>
  );
}
